import Splide from '@splidejs/splide';

let expertiseSlides = document.getElementsByClassName('expertise-slider');
let expertiseNav = document.getElementsByClassName('expertise-slider-nav');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < expertiseSlides.length; i++) {
        let content = new Splide(expertiseSlides[i], {
            type: 'loop',
            pagination: false,
            arrows: true,
            rewind: true,
            perPage: 2,
            perMove: 1,
            gap: '24px',
            width: '100%',
            breakpoints: {
                1023: {
                    gap: '16px',
                },
                768: {
                    perPage: 1,
                },
            }
        });

        let nav = new Splide(expertiseNav[i], {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            rewind: true,
            pagination: false,
            isNavigation: true,
            arrows: false
        });

        let bar = content.root.querySelector('.splide-progress-bar');

        content.on('mounted move', function () {
            let end = content.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (content.index + 1) / end) + '%';
        });

        //sync the content with the navigation
        content.sync(nav);
        content.mount();
        nav.mount();
    }
});
